module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/core-js/library/modules/_redefine.js
// module id = 270
// module chunks = 1